module.exports = __webpack_public_path__ + "img/orange_062.5cc7b922.png";